import { render, staticRenderFns } from "./TaskItemRow.vue?vue&type=template&id=4f703c79&scoped=true"
import script from "./TaskItemRow.vue?vue&type=script&lang=js"
export * from "./TaskItemRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f703c79",
  null
  
)

export default component.exports